import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';

import { PreferencesOverviewComponent } from './components/preferences-overview/preferences-overview.component';
import { loadPreferenceGroupsRequest } from './store/preferences.actions';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PreferencesOverviewComponent],
})
export class PreferencesComponent implements OnInit {
  constructor(private readonly store: Store<RootState>) {}

  ngOnInit(): void {
    this.store.dispatch(loadPreferenceGroupsRequest());
  }
}
